import { ErrorMessage, Field, FieldArray, Form, FormikProvider, useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { config } from "../../CommonUtils/CommonURLS";
import { CommonAxiosGet, CommonAxiosPost } from "../../CommonUtils/CommonAxios";
import allowNumbersOnly, { allowAlphabetAndSpacesOnly, handlePaste } from "../../CommonUtils/CommonValidations";
import Swal from "sweetalert2";
import * as Yup from 'yup';
import { useDispatch, useSelector } from "react-redux";
import { getCollNaturelist, getDistricts, gethabitationlist, getMandals, getVillages } from "../../Reducers/AffiliationCommonservice";
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { viewImage } from "../../CommonUtils/viewImage";
import { FaEye } from "react-icons/fa";
import * as bie from "react-bootstrap";
import { ImagePdfBucket } from "../../CommonUtils/ImagesBase64";
import { ApPINCODE, ERROR_MSG, MOBILE_VALIDATION, pantanRegex } from "../../CommonUtils/contextVariables";
import { failureAlert, successAlert2 } from "../../CommonUtils/SweetAlerts";
import CommonFormHeading from "../../CommonUtils/CommonFormHeading";
import { VscDiffAdded, VscDiffRemoved } from "react-icons/vsc";

export default function AfiliationApplication() {
    const hasFetchedData = useRef(false)
    const name = sessionStorage.getItem('collegeName')
    const districtmst = useSelector((state) => state?.commonMastersReducer?.DistList);
    const mandalmst = useSelector((state) => state?.commonMastersReducer?.mandalList);
    const villagemst = useSelector((state) => state?.commonMastersReducer?.villageList);
    const habitationlist = useSelector((state) => state?.commonMastersReducer?.habitationList);
    const collNatureLIST = useSelector((state) => state?.commonMastersReducer?.collNatureLIST);
    const dispatch = useDispatch();
    const instname = sessionStorage.getItem('instName'); // "college" or "ffca" or "university"


    const validationSchema = Yup.object().shape({
        // collAisheCode: Yup.string().required(ERROR_MSG).nullable(),
        collNatureCode: Yup.string().required(ERROR_MSG).nullable(),
        instEstd: Yup.string().required(ERROR_MSG).nullable(),
        instName: Yup.string().required(ERROR_MSG).nullable(),
        instPan: Yup.string().matches(pantanRegex, "Invalid Pan/Tan No").required(ERROR_MSG).nullable(),
        instAddrProofType: Yup.string().required(ERROR_MSG).nullable(),
        instAddrProofPdf: Yup.string().required(ERROR_MSG).nullable(),
        instAddress: Yup.string().required(ERROR_MSG).nullable(),
        instStreet: Yup.string().required(ERROR_MSG).nullable(),
        instDistCode: Yup.string().required(ERROR_MSG).nullable(),
        instMandalCode: Yup.string().required(ERROR_MSG).nullable(),
        instVillageCode: Yup.string().required(ERROR_MSG).nullable(),
        constiency: Yup.string().required(ERROR_MSG).nullable(),

        instHabitationCode: Yup.string().required(ERROR_MSG).nullable(),
        // mroOffice: Yup.string().required(ERROR_MSG).nullable(),
        instPincode: Yup.string().matches(ApPINCODE, 'Must be a valid 6-digit pincode').test('no-all-zeros', 'Pincode cannot be all zeros', value => value !== '000000').required(ERROR_MSG).nullable(),
        instLandmark: Yup.string().required(ERROR_MSG).nullable(),
        instMobile: Yup.string().matches(MOBILE_VALIDATION, 'Must be a valid mobile number').required(ERROR_MSG).nullable(),
        instEmail: Yup.string().email('Must be a valid email').required(ERROR_MSG).nullable(),
        instPhone: Yup.string().matches(/^\d{10}$/, 'Must be a valid 10-digit phone number').required(ERROR_MSG).nullable(),
        instWebsite: Yup.string().required(ERROR_MSG).nullable(),
        // collegeType: Yup.string().required(ERROR_MSG).nullable(),
        instStatus: Yup.string().required(ERROR_MSG).nullable(),
        instMinority: Yup.string().required(ERROR_MSG).nullable(),

        instMinorityType: Yup.string().when('instMinority', {
            is: "true",
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().notRequired(),
        }),
        minorityStatCerti: Yup.string().when('instMinority', {
            is: "true",
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().notRequired()
        }),
        otherSpecificMinority: Yup.string().when(['instMinority', 'instMinorityType'], {
            is: (instMinority, instMinorityType) => instMinority == "true" && instMinorityType === 'OS',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().notRequired(),
        }),



        competantAuthority: Yup.string().required(ERROR_MSG).nullable(),
        competantAuthorityDate: Yup.date().required(ERROR_MSG).nullable(),
        competantAuthorityPdf: Yup.string().required(ERROR_MSG).nullable(),
        isEop: Yup.string().required(ERROR_MSG).nullable(),

        latEopDateNew: Yup.date().when('isEop', {
            is: true,
            then: Yup.date()
                .nullable()
                .required(ERROR_MSG)
                .transform((value, originalValue) => (originalValue === '' ? null : value)),
            otherwise: Yup.date().notRequired(),
        }),

        latEopOrderPdfNew: Yup.string().when('isEop', {
            is: true,
            then: Yup.string()
                .nullable()
                .required(ERROR_MSG)
                .transform((value, originalValue) => (originalValue === '' ? null : value)),
            otherwise: Yup.string().notRequired(),
        }),
        automusNonautomus: Yup.string().required(ERROR_MSG).nullable(),
        ugcStatDateUpFrom: Yup.date().when('automusNonautomus', {
            is: 'A',
            then: Yup.date().required(ERROR_MSG).nullable(),
            otherwise: Yup.date().notRequired()
        }),

        ugcStatDateUpto: Yup.string().when('automusNonautomus', {
            is: 'A',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().notRequired()
        }),
        ugcYrAfflOrder: Yup.string().when('automusNonautomus', {
            is: 'A',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().notRequired()
        }),
        autoNonautoUniv: Yup.string().required(ERROR_MSG),
        univStatDateFrom: Yup.date().when('autoNonautoUniv', {
            is: 'A',
            then: Yup.date().required(ERROR_MSG).nullable(),
            otherwise: Yup.date().notRequired()
        }),
        univStatDateUpto: Yup.date().when('autoNonautoUniv', {
            is: 'A',
            then: Yup.date().required(ERROR_MSG).nullable(),
            otherwise: Yup.date().notRequired()
        }),

        universityYrAfflOrder: Yup.string().when('autoNonautoUniv', {
            is: 'A',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().notRequired()
        }),
        instUgc: Yup.string().required(ERROR_MSG).nullable(),
        instUgcType: Yup.string().when('instUgc', {
            is: 'Yes',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().notRequired()
        }),

        ugcCerti: Yup.string().when("instUgc", {
            is: (instUgc) => (instUgc === "Yes" ? true : false),
            then: Yup.string().required(ERROR_MSG).nullable(), oterwise: Yup.string(),
        }),
        naacStatus: Yup.string().when('naacAccredited', {
            is: 'Yes',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().notRequired()
        }),


        nbaAccrediated: Yup.string().required(ERROR_MSG).nullable(),
        nbaFromDate: Yup.date().when('nbaAccrediated', {
            is: 'Yes',
            then: Yup.date().required(ERROR_MSG).nullable(),
            otherwise: Yup.date().notRequired()
        }),
        nbaUptoDate: Yup.date().when('nbaAccrediated', {
            is: 'Yes',
            then: Yup.date().required(ERROR_MSG).nullable(),
            otherwise: Yup.date().notRequired()
        }),

        nbaAccredCerti: Yup.string().when('nbaAccrediated', {
            is: (value) => ['Yes', 'nullnull'].includes(value),
            then: Yup.string().required('required').nullable(),
            otherwise: Yup.string().notRequired().nullable(),
        }),

        nbaCgpa: Yup.string().when('nbaAccrediated', {
            is: 'Yes',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().notRequired()
        }),

        cetsmapped: Yup.array().of(
            Yup.object().shape({
                collCetName: Yup.string().required(ERROR_MSG).nullable(),
                cetsCode: Yup.string().required(ERROR_MSG).nullable(),


            })
        ),


        naacAccredited: Yup.string()
            .required("Required"),

        // ================= LATEST NAAC =================
        naacStatus: Yup.string().when("naacAccredited", {
            is: "Yes",
            then: (schema) => schema.required("Grade is required"),
            otherwise: (schema) => schema.notRequired()
        }),

        latestNaacCgpa: Yup.number()
            .typeError("CGPA must be a number")
            .when("naacAccredited", {
                is: "Yes",
                then: (schema) =>
                    schema.required("CGPA is required")
                        .min(0)
                        .max(4),
                otherwise: (schema) => schema.notRequired()
            }),

        latestNaacFromDate: Yup.date().when("naacAccredited", {
            is: "Yes",
            then: (schema) => schema.required("From Date required"),
            otherwise: (schema) => schema.notRequired()
        }),

        latestNaacUptoDate: Yup.date()
            .when("naacAccredited", {
                is: "Yes",
                then: (schema) =>
                    schema.required("To Date required")
                        .min(Yup.ref("latestNaacFromDate"), "Invalid date"),
                otherwise: (schema) => schema.notRequired()
            }),

        latestNaacCerti: Yup.mixed().when("naacAccredited", {
            is: "Yes",
            then: (schema) => schema.required("Certificate required"),
            otherwise: (schema) => schema.notRequired()
        }),

        // ================= PREVIOUS =================
        hasPreviousNaac: Yup.string().required("Required"),
        secretariat: Yup.string().required("Required"),
        parliament: Yup.string().required("Required"),
        naacCycle: Yup.string().when(
            ["naacAccredited", "hasPreviousNaac"],
            {
                is: (a, p) => a === "Yes" && p === "Yes",
                then: (schema) => schema.required("NAAC Cycle is required"),
                otherwise: (schema) => schema.notRequired()
            }
        ),

        naacDetails: Yup.array().when(
            ["naacAccredited", "hasPreviousNaac"],
            {
                is: (a, p) => a === "Yes" && p === "Yes",
                then: (schema) =>
                    schema
                        .of(
                            Yup.object().shape({

                                naacFromDate: Yup.date()
                                    .required("From Date required"),
                                naacStatus: Yup.string()
                                    .required("Required"),

                                naacUptoDate: Yup.date()
                                    .required("To Date required")
                                    .min(
                                        Yup.ref("naacFromDate"),
                                        "To Date must be after From Date"
                                    ),

                                naacAccredCerti: Yup.mixed()
                                    .required("Certificate required"),

                                naacCgpa: Yup.number()
                                    .typeError("Must be number")
                                    .required("CGPA required")
                                    .min(1)
                                    .max(4)
                            })
                        )
                        .test(
                            "length-check",
                            "NAAC details must match selected cycle",
                            function (value) {
                                const { naacCycle } = this.parent;
                                if (!naacCycle) return true;
                                return value?.length === parseInt(naacCycle);
                            }
                        ),

                otherwise: (schema) => schema.notRequired()
            }
        )

    });

    const formik = useFormik({
        initialValues: {
            collNatureCode: '',
            instEstd: '',
            instName: '',
            instPan: '',
            instAddrProofType: '',
            instAddrProofPdf: '',
            instAddress: '',
            instStreet: '',
            instDistCode: '',
            instMandalCode: '',
            instVillageCode: '',
            instHabitationCode: '',
            // mroOffice: '',
            instPincode: '',
            instLandmark: '',
            offCampusAddress: '',
            instMobile: '',
            instEmail: '',
            instPhone: '',
            instWebsite: '',
            // collegeType: '',
            instStatus: '',
            offCampusInstStatus: '',
            instMinority: '',
            instMinorityType: '',
            otherSpecificMinority: '',
            minorityStatCerti: '',
            instExamCollCode: '',
            eamcetCode: '',
            icetCode: '',
            competantAuthority: '',
            competantAuthorityDate: '',
            competantAuthorityPdf: '',
            isEop: '',
            latEopDateNew: '',
            latEopOrderPdfNew: '',
            automusNonautomus: '',
            ugcStatDateUpFrom: '',
            ugcStatDateUpto: '',
            ugcYrAfflOrder: '',
            autoNonautoUniv: '',
            univStatDateFrom: '',
            univStatDateUpto: '',
            universityYrAfflOrder: '',
            instUgc: '',
            instUgcType: '',
            ugcCerti: '',
            // naacAccredited: '',
            naacStatus: '',

            nbaAccrediated: '',
            nbaFromDate: '',
            nbaUptoDate: '',
            nbaAccredCerti: '',
            nbaCgpa: '',
            collAisheCode: "",
            constiency: "",

            cetsmapped: [{
                collCetName: '',
                cetsCode: '',
            }],


            naacAccredited: "",
            naacStatus: "",
            latestNaacFromDate: "",
            latestNaacUptoDate: "",
            latestNaacCerti: "",
            latestNaacCgpa: "",

            hasPreviousNaac: "",

            naacCycle: "",
            naacDetails: [],
            secretariat: "",
            parliament: "",
        },
        validationSchema: validationSchema,
        enableReinitialize: true,
        onSubmit: (val) => {
            console.log("VAAAAAAAAAl,val", val)
            Swal.fire({
                title: 'Are you sure want to submit ?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Submit',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    let url = config.url.API_URL + `AfiliationApplication`
                    CommonAxiosPost(url, val, dispatch).then((res) => {
                        if (res?.data?.scode === '01') {
                            successAlert2(res?.data?.sdesc);
                            AfflApplicationData();
                        }
                        else {
                            failureAlert("Failed to submit")
                        }
                    })
                }
            })
        }
    })



    const [Application, setApplication] = useState([])
    function AfflApplicationData() {
        let url = config.url.API_URL + `getInstData`
        CommonAxiosGet(url, dispatch).then((res) => {
            if (res?.data?.scode === '01') {
                let dd = res?.data?.getLatpdf[0]
                setApplication(res?.data?.getLatpdf[0])
                const CompetantAuthorityDate = dd?.competant_authority_date && moment(dd?.competant_authority_date,
                    'DD/MM/YYYY', true).isValid() ? moment(dd?.competant_authority_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;
                const LatEopDateNew = dd?.lat_eop_date_new && moment(dd?.lat_eop_date_new,
                    'DD/MM/YYYY', true).isValid() ? moment(dd?.lat_eop_date_new, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;
                const ugcStatDateUpFrom = dd?.ugc_stat_date_from && moment(dd?.ugc_stat_date_from,
                    'DD/MM/YYYY', true).isValid() ? moment(dd?.ugc_stat_date_from, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;
                const ugcStatDateUpto = dd?.ugc_stat_date_upto && moment(dd?.ugc_stat_date_upto,
                    'DD/MM/YYYY', true).isValid() ? moment(dd?.ugc_stat_date_upto, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;
                const univStatDateFrom = dd?.univ_stat_date_from && moment(dd?.univ_stat_date_from,
                    'DD/MM/YYYY', true).isValid() ? moment(dd?.univ_stat_date_from, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;
                const univStatDateUpto = dd?.univ_stat_date_upto && moment(dd?.univ_stat_date_upto,
                    'DD/MM/YYYY', true).isValid() ? moment(dd?.univ_stat_date_upto, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;
                const naacFromDate = dd?.naac_from_date && moment(dd?.naac_from_date,
                    'DD/MM/YYYY', true).isValid() ? moment(dd?.naac_from_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;
                const naacUptoDate = dd?.naac_upto_date && moment(dd?.naac_upto_date,
                    'DD/MM/YYYY', true).isValid() ? moment(dd?.naac_upto_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;
                const nbaFromDate = dd?.nba_from_date && moment(dd?.nba_from_date,
                    'DD/MM/YYYY', true).isValid() ? moment(dd?.nba_from_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;
                const nbaUptoDate = dd?.nba_upto_date && moment(dd?.nba_upto_date,
                    'DD/MM/YYYY', true).isValid() ? moment(dd?.nba_upto_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;

                formik?.setFieldValue("ugcStatDateUpFrom", ugcStatDateUpFrom ?? '');
                formik?.setFieldValue("collAisheCode", dd?.coll_aishe_code ?? '');

                formik?.setFieldValue("ugcStatDateUpto", ugcStatDateUpto ?? '');
                formik?.setFieldValue("univStatDateFrom", univStatDateFrom ?? '');
                formik?.setFieldValue("univStatDateUpto", univStatDateUpto ?? '');
                // formik?.setFieldValue("naacFromDate", naacFromDate ?? '');
                // formik?.setFieldValue("naacUptoDate", naacUptoDate ?? '');
                formik?.setFieldValue("nbaFromDate", nbaFromDate ?? '');
                formik?.setFieldValue("nbaUptoDate", nbaUptoDate ?? '');

                formik?.setFieldValue("collNatureCode", dd?.coll_nature_code);
                formik?.setFieldValue("instEstd", dd?.inst_estd);
                formik?.setFieldValue("instName", dd?.inst_name);
                formik?.setFieldValue("instPan", dd?.inst_pan);
                formik?.setFieldValue("instAddrProofType", dd?.college_type);
                if (dd?.inst_addr_proof_pdf !== null && dd?.inst_addr_proof_pdf !== undefined && dd?.inst_addr_proof_pdf !== '') {

                    formik?.setFieldValue("instAddrProofPdf", dd?.inst_addr_proof_pdf || '');
                }
                formik?.setFieldValue("instAddress", dd?.inst_address);
                formik?.setFieldValue("instStreet", dd?.inst_street);
                formik?.setFieldValue("instDistCode", dd?.inst_dist_code);



                GetConstiencyData(dd?.inst_dist_code, dispatch);
                formik?.setFieldValue("constiency", dd?.constiency);
                GetSecrateraitList(dd?.inst_dist_code, dispatch);
                formik?.setFieldValue("secretariat", dd?.secretariat ?? '');
                GetParlData(dd?.inst_dist_code, dispatch);
                formik?.setFieldValue("parliament", dd?.parlment ?? '');

                getMandals(dd?.inst_dist_code, dispatch);

                formik?.setFieldValue("instMandalCode", dd?.inst_mandal_code);
                getVillages(dd?.inst_dist_code, dd?.inst_mandal_code, dispatch);
                formik?.setFieldValue("instVillageCode", dd?.inst_village_code);
                gethabitationlist(dd?.inst_dist_code, dd?.inst_mandal_code, dispatch);


                formik?.setFieldValue("instHabitationCode", dd?.inst_habitation_code);
                formik?.setFieldValue("mroOffice", dd?.mro_office);
                formik?.setFieldValue("instPincode", dd?.inst_pincode);
                formik?.setFieldValue("instLandmark", dd?.inst_landmark);
                formik?.setFieldValue("offCampusAddress", dd?.off_campus_address);
                formik?.setFieldValue("instMobile", dd?.inst_mobile);
                formik?.setFieldValue("instEmail", dd?.inst_email);
                formik?.setFieldValue("instPhone", dd?.inst_phone);
                formik?.setFieldValue("instWebsite", dd?.inst_website);
                // formik?.setFieldValue("collegeType", dd?.college_type);
                formik?.setFieldValue("instStatus", dd?.inst_status ?? '');
                formik?.setFieldValue("offCampusInstStatus", dd?.off_campus_inst_status || '');
                formik?.setFieldValue("instMinority", dd?.inst_minority?.toString() ?? "");
                formik?.setFieldValue("instMinorityType", dd?.inst_minority_type?.toString() ?? '');
                formik?.setFieldValue("otherSpecificMinority", dd?.other_specific_minority ?? '');
                if (dd?.minority_stat_certi !== null && dd?.minority_stat_certi !== undefined && dd?.minority_stat_certi !== '') {

                    formik?.setFieldValue("minorityStatCerti", dd?.minority_stat_certi || '');
                }
                formik?.setFieldValue("instExamCollCode", dd?.inst_exam_coll_code || '');
                formik?.setFieldValue("eamcetCode", dd?.eamcet_code ?? '');
                formik?.setFieldValue("icetCode", dd?.icet_code);
                formik?.setFieldValue("competantAuthority", dd?.competant_authority);
                formik?.setFieldValue("competantAuthorityDate", CompetantAuthorityDate ?? '')
                if (dd?.competant_authority_pdf !== null && dd?.competant_authority_pdf !== undefined && dd?.competant_authority_pdf !== '') {

                    formik?.setFieldValue("competantAuthorityPdf", dd?.competant_authority_pdf || '');
                }


                if (dd?.is_eop !== null && dd?.is_eop !== undefined && dd?.is_eop !== '') {
                    formik.setFieldValue('isEop', dd.is_eop.toString() ?? '');
                }

                formik?.setFieldValue("latEopDateNew", LatEopDateNew ?? '');
                if (dd?.lat_eop_order_pdf_new !== null && dd?.lat_eop_order_pdf_new !== undefined && dd?.lat_eop_order_pdf_new !== '') {

                    formik?.setFieldValue("latEopOrderPdfNew", dd?.lat_eop_order_pdf_new ?? '');
                }
                formik?.setFieldValue("automusNonautomus", dd?.automus_nonautomus);
                if (dd?.ugc_yr_affl_order !== null && dd?.ugc_yr_affl_order !== undefined && dd?.ugc_yr_affl_order !== '') {

                    formik?.setFieldValue("ugcYrAfflOrder", dd?.ugc_yr_affl_order);
                }

                if (dd?.auto_nonauto_univ !== null && dd?.auto_nonauto_univ !== undefined && dd?.auto_nonauto_univ !== '') {
                    formik.setFieldValue('autoNonautoUniv', dd.auto_nonauto_univ.toString() ?? '');
                }


                formik?.setFieldValue("universityYrAfflOrder", dd?.university_yr_affl_order ?? '');
                formik?.setFieldValue("instUgc", dd?.inst_ugc?.toString() ?? '');
                formik?.setFieldValue("instUgcType", dd?.inst_ugc_type || '');
                if (dd?.ugc_certi !== null && dd?.ugc_certi !== undefined && dd?.ugc_certi !== '') {
                    formik?.setFieldValue("ugcCerti", dd?.ugc_certi ?? '');
                }
                // ....NACC>>>>>>>>>>>>>>>>
                formik?.setFieldValue("naacAccredited", dd?.naac_accrediated.toString() ?? '');
                formik?.setFieldValue("latestNaacCgpa", dd?.latest_naac_cgpa?.toString() ?? '');
                formik?.setFieldValue("latestNaacFromDate", dd?.latest_naac_from_date?.toString() ?? '');
                formik?.setFieldValue("latestNaacUptoDate", dd?.latest_naac_upto_date?.toString() ?? '');
                // formik?.setFieldValue("latestNaacCerti", dd?.latest_naac_certi?.toString() ?? '');
                formik?.setFieldValue("hasPreviousNaac", dd?.has_previous_naac?.toString() ?? '');
                formik?.setFieldValue("naacStatus", dd?.naac_status?.toString() ?? '');

                formik?.setFieldValue("naacCycle", dd?.naac_cycle?.toString() ?? '');

                if (dd?.latest_naac_certi !== null && dd?.latest_naac_certi !== undefined && dd?.latest_naac_certi !== '') {
                    formik?.setFieldValue("latestNaacCerti", dd?.latest_naac_certi);
                }
                formik?.setFieldValue("nbaAccrediated", dd?.nba_accrediated.toString() ?? '');
                if (dd?.nba_accred_certi !== null && dd?.nba_accred_certi !== undefined && dd?.nba_accred_certi !== '') {
                    formik?.setFieldValue("nbaAccredCerti", dd?.nba_accred_certi ?? '');
                }
                formik?.setFieldValue("nbaCgpa", dd?.nba_cgpa);
                res?.data?.naacDtls?.forEach((data, i) => {
                    formik?.setFieldValue(`naacDetails[${i}].naacCgpa`, data?.naac_cgpa)
                    formik?.setFieldValue(`naacDetails[${i}].naacAccredCerti`, data?.naac_accred_certi)
                    formik?.setFieldValue(`naacDetails[${i}].naacFromDate`, data?.naac_from_date)
                    formik?.setFieldValue(`naacDetails[${i}].naacUptoDate`, data?.naac_upto_date)
                    formik?.setFieldValue(`naacDetails[${i}].naacStatus`, data?.naac_status)

                    if (dd?.naac_accred_certi !== null && dd?.naac_accred_certi !== undefined && dd?.naac_accred_certi !== '') {
                        formik?.setFieldValue(`naacDetails[${i}].naacAccredCerti`, dd?.naac_accred_certi);
                    }

                })
                // const naacList = res?.data?.naacDtls;

                // if (naacList) {
                //     const safeArray = Array.isArray(naacList) ? naacList : [naacList];

                //     formik.setFieldValue("naacDetails", safeArray.map(item => ({
                //         naacCgpa: item?.naac_cgpa || "",
                //         naacAccredCerti: item?.naac_accred_certi || "",
                //         naacFromDate: item?.naac_from_date || "",
                //         naacUptoDate: item?.naac_upto_date || ""
                //     })));
                // }

            }
        })
    }

    function GetCetsMappedData() {
        let url = config.url.API_URL + `getcollcetsMap`;

        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                res?.data?.data?.forEach((data, i) => {
                    formik?.setFieldValue(`cetsmapped[${i}].collCetName`, data?.coll_cet_name ?? '');
                    formik?.setFieldValue(`cetsmapped[${i}].cetsCode`, data?.cet_code);

                })

            } else {
                formik.setFieldValue('cetsmapped', [
                    {
                        collCetName: '',
                        cetsCode: '',
                    },
                ]);

            }
        });
    }

    const [constList, setConstList] = useState([]);
    function GetConstiencyData(distcode) {
        if (!distcode) {

            return;
        }
        CommonAxiosGet(`${config.url.API_URL}getConstituencyList?distcode=${distcode}`).then((res) => {
            setConstList(res?.data?.scode === "01" ? res.data.list || [] : []);
        });
    }

    const [secretdata, setSecretData] = useState([]);
    function GetSecrateraitList(distcode) {
        if (!distcode) {

            return;
        }
        let url = config.url.API_URL + `getSecraterietList?distcode=${distcode}`
        CommonAxiosGet(url).then((res) => {
            if (res?.data) {
                setSecretData(res?.data?.list);

            } else {
                setSecretData([]);
            }
        })
    }


    const [parlmentdata, setparlmentdata] = useState([]);
    function GetParlData() {
        let url = config.url.API_URL + `getParlmentList`
        CommonAxiosGet(url).then((res) => {
            if (res?.data) {
                setparlmentdata(res?.data?.list);

            } else {
                setparlmentdata([]);
            }
        })
    }

    const [clgtype, setClgtype] = useState('');
    function GetOAMDCClgType() {
        let url = config.url.API_URL + `getOamdcType`
        CommonAxiosGet(url).then((res) => {
            if (res?.data) {
                setClgtype(res?.data)

            } else {
                setClgtype([])
            }
        })
    }


    const [cfmsdata, setCfmsdata] = useState('');
    function GetCfmsData(cfmsid) {
        if (!cfmsid) {
            return;
        }

        let url = config.url.API_URL + `getInstDetailsByAishe?aisheCode=${cfmsid}`
        CommonAxiosGet(url).then((res) => {
            if (res?.data) {
                setCfmsdata(res?.data?.data);

            } else {
                setCfmsdata([]);
            }
        })
    }

    const [cetList, setcetList] = useState([]);
    function GetCetsList() {
        let url = config.url.API_URL + `getcetsMst`
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setcetList(res?.data?.data)
            } else {
                setcetList([])
            }
        })
    }
    useEffect(() => {
        if (!hasFetchedData?.current) {
            GetParlData();
            getDistricts();
            getCollNaturelist();
            GetCetsList();
            AfflApplicationData();
            GetCetsMappedData();
            GetOAMDCClgType();
            hasFetchedData.current = true
        }

    }, [])


    console.log("formik", formik?.errors);

    return (
        <>
            <CommonFormHeading heading={`College & Approval Details For ${instname} `} />

            <FormikProvider value={formik}>
                <Form onChange={formik.handleChange} onSubmit={formik.handleSubmit} className="affl-form">
                    <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5 " >
                        <bie.Row className="px-3 pt-4 m-0">
                            <bie.Col xs={12} sm={12} md={12} lg={5} xl={4} xxl={3}>
                                <label classname='mb-1'><b className='mt-2' style={{ color: 'red' }}>* </b><b>Nature of the college :</b></label>
                                <Field as="select" name="collNatureCode" className="form-control mb-2" >
                                    <option value=''>--SELECT--</option>
                                    {collNatureLIST !== 'No data found' && collNatureLIST?.map((ss, i) => (
                                        <option value={ss?.coll_nature_code} key={i}>{ss?.coll_nature_name}</option>
                                    ))}
                                </Field>
                                <ErrorMessage name="collNatureCode" component="div" className="text-error" />
                            </bie.Col>
                            <div className="inner-herbpage-service-title-sub"  >
                                <h1 className="mb-0">Institution Details</h1>
                            </div>
                            <div className="">
                                <bie.Row className="my-3">




                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Name of the University   </label>
                                        <Field type="text" value={name} disabled name="societyHeadDist" className="form-control mb-2" />
                                    </bie.Col>

                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}  >
                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Year of Estd. </label>
                                        <Field name="instEstd">
                                            {({ field, form }) => (
                                                <DatePicker
                                                    selected={field.value ? new Date(field.value, 0, 1) : null}
                                                    onChange={(date) => {
                                                        const year = date ? date.getFullYear().toString() : '';
                                                        form.setFieldValue(field.name, year);
                                                    }}
                                                    showYearPicker
                                                    dateFormat="yyyy"
                                                    className="form-control mb-2"
                                                    minDate={new Date(1950, 0, 1)}
                                                    maxDate={new Date()}

                                                />
                                            )}
                                        </Field>
                                        <ErrorMessage name="instEstd" component="div" className="text-error" />
                                        {/* </bie.InputGroup> */}
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                        {/* <bie.InputGroup > */}
                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>College Name </label>
                                        <Field type="text" name="instName" className="form-control mb-2" onKeyPress={(e) => { allowAlphabetAndSpacesOnly(e) }} maxLength="60" />
                                        <ErrorMessage name="instName" component="div" className="text-error" />
                                        {/* </bie.InputGroup> */}
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                        {/* <bie.InputGroup > */}
                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>College PAN/TAN No</label>
                                        <Field type="text" name="instPan" className="form-control down-marg4" maxLength='10' onKeyUp={(e) => { formik.setFieldValue("instPan", e.target.value.toUpperCase()) }} />
                                        <ErrorMessage name="instPan" component="div" className="text-error" />
                                        {/* </bie.InputGroup> */}
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                        {/* <bie.InputGroup > */}
                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Type of College   </label>
                                        <Field as="select" name="instAddrProofType" className="form-control mb-2" >
                                            <option value=''>--SELECT--</option>
                                            <option value="Integrated">Integrated</option>
                                            <option value="Standalone">Standalone</option>
                                            {/* <option value="Conventional">Conventional</option> */}
                                        </Field>
                                        <ErrorMessage name="instAddrProofType" component="div" className="text-error" />
                                        {/* </bie.InputGroup> */}
                                    </bie.Col>

                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}  >
                                        {/* <bie.InputGroup> */}
                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Upload Address Proof  </label>
                                        <div className="d-flex align-items-center">
                                            <input type="file" name="instAddrProofPdf" className="form-control down-marg4" accept="application/pdf"
                                                onChange={(e) => {
                                                    let filename = `instAddrProofPdf`;
                                                    let path = "/Uploads/AffiliationPDFs/2023/"
                                                    ImagePdfBucket(e, formik, path, `instAddrProofPdf`, filename, "pdf");
                                                }}
                                            /> &nbsp;
                                            {Application?.inst_addr_proof_pdf && <button type='button' className='btn btn-primary' onClick={() => { viewImage(Application?.inst_addr_proof_pdf) }}><FaEye size={23} /></button>}
                                        </div>



                                        <ErrorMessage name="instAddrProofPdf" component="div" className="text-error" />
                                        {/* </bie.InputGroup> */}
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                        {/* <bie.InputGroup > */}
                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>House/Door/Plot No </label>
                                        <Field type="text" name="instAddress" className="form-control mb-2" maxLength='20' />
                                        <ErrorMessage name="instAddress" component="div" className="text-error" />
                                        {/* </bie.InputGroup> */}
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                        {/* <bie.InputGroup > */}
                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Street/Road</label>
                                        <Field type="text" name="instStreet" className="form-control mb-2" maxLength='30' />
                                        <ErrorMessage name="instStreet" component="div" className="text-error" />
                                        {/* </bie.InputGroup> */}
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >

                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>District </label>
                                        <Field as="select" name="instDistCode" className="form-control mb-2" onChange={(e) => {
                                            getMandals(e.target.value, dispatch); GetConstiencyData(e?.target?.value); GetSecrateraitList(e?.target?.value);
                                            formik?.setFieldValue("instMandalCode", "")
                                            formik?.setFieldValue("instVillageCode", "")
                                            formik?.setFieldValue("instHabitationCode", "")
                                            formik?.setFieldValue("secretariat", "")
                                            formik?.setFieldValue("constiency", "")

                                        }} >
                                            <option value=''>--SELECT--</option>
                                            {districtmst !== 'No data found' && districtmst?.map((dd, i) => (
                                                <option value={dd?.dist_code} key={i}>{dd?.dist_name}</option>
                                            ))}
                                        </Field>
                                        <ErrorMessage name="instDistCode" component="div" className="text-error" />

                                    </bie.Col>

                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >

                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>*  </b>Assembly Constituency </label>
                                        <Field as="select" name="constiency" className="form-control mb-2" onChange={(e) => {
                                            // getMandals(e.target.value, dispatch)
                                            // formik?.setFieldValue("instDistCode", "")

                                        }} >
                                            <option value=''>--SELECT--</option>
                                            {constList !== 'No data found' && constList?.map((dd, i) => (
                                                <option value={dd?.constituency_code} key={i}>{dd?.constituency_name}</option>
                                            ))}
                                        </Field>
                                        <ErrorMessage name="constiency" component="div" className="text-error" />

                                    </bie.Col>

                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >

                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>*  </b>secretariat  </label>
                                        <Field as="select" name="secretariat" className="form-control mb-2" >
                                            <option value=''>--SELECT--</option>
                                            {secretdata !== 'No data found' && secretdata?.map((dd, i) => (
                                                <option value={dd?.secretariat_code} key={i}>{dd?.secretariat_name}</option>
                                            ))}
                                        </Field>
                                        <ErrorMessage name="secretariat" component="div" className="text-error" />

                                    </bie.Col>

                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >

                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>*  </b>Parliament  </label>
                                        <Field as="select" name="parliament" className="form-control mb-2" >
                                            <option value=''>--SELECT--</option>
                                            {parlmentdata !== 'No data found' && parlmentdata?.map((dd, i) => (
                                                <option value={dd?.pc_code} key={i}>{dd?.parliamentary_constituency}</option>
                                            ))}
                                        </Field>
                                        <ErrorMessage name="parliament" component="div" className="text-error" />

                                    </bie.Col>


                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >

                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Mandal </label>
                                        <Field as="select" name="instMandalCode" className="form-control mb-2"
                                            //  onChange={(e) => {
                                            //     getVillages(formik?.values?.instDistCode, e.target.value, dispatch); gethabitationlist(formik?.values?.instDistCode, e.target.value, dispatch)
                                            //     formik?.setFieldValue("instVillageCode", "")
                                            //     formik?.setFieldValue("instHabitationCode", "")
                                            // }}>
                                            onChange={(e) => {
                                                const distCode = formik?.values?.instDistCode;
                                                const mandalCode = e.target.value;

                                                // Reset dependent fields
                                                formik?.setFieldValue("instVillageCode", "");
                                                formik?.setFieldValue("instHabitationCode", "");

                                                // Only call APIs if both codes are valid
                                                if (distCode && mandalCode) {
                                                    getVillages(distCode, mandalCode, dispatch);
                                                    gethabitationlist(distCode, mandalCode, dispatch);
                                                } else {
                                                    // Clear lists if mandal is empty
                                                    dispatch({ type: "VILLAGESLIST", payload: [] });
                                                    dispatch({ type: "HabitationLIST", payload: [] });
                                                }
                                            }}
                                        >
                                            <option value=''>--SELECT--</option>
                                            {mandalmst !== 'No data found' && mandalmst?.map((mm, i) => (
                                                <option value={mm?.mandal_code} key={i}>{mm?.mandal_name}</option>
                                            ))}
                                        </Field>
                                        <ErrorMessage name="instMandalCode" component="div" className="text-error" />

                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >

                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Village  </label>
                                        <Field as="select" name="instVillageCode" className="form-control mb-2">
                                            <option value=''>--SELECT--</option>
                                            {villagemst !== 'No data found' && villagemst?.map((vv, i) => (
                                                <option value={vv?.village_code} key={i}>{vv?.village_name}</option>
                                            ))}
                                        </Field>
                                        <ErrorMessage name="instVillageCode" component="div" className="text-error" />

                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >

                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Habitation   </label>
                                        <Field as="select" name="instHabitationCode" className="form-control mb-2" placeholder='habitation list'>
                                            <option value=''>--SELECT--</option>
                                            {habitationlist !== "No data found" && habitationlist?.map((vv, i) => (
                                                <option value={vv?.habitation_code} key={i}>{vv?.habitation}</option>
                                            ))}
                                        </Field>
                                        <ErrorMessage name="instHabitationCode" component="div" className="text-error" />

                                    </bie.Col>
                                    {/* <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Address of the MRO Office   </label>
                                        <Field type="text" name="mroOffice" className="form-control mb-2" maxLength="40" />
                                        <ErrorMessage name="mroOffice" component="div" className="text-error" />
                                    </bie.Col> */}

                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}  >
                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Pin Code </label>
                                        <Field type="text" name="instPincode" className="form-control mb-2" maxLength='6' onKeyPress={(e) => { allowNumbersOnly(e) }} onPaste={(e) => handlePaste(e)} />
                                        <ErrorMessage name="instPincode" component="div" className="text-error" />
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                        {/* <bie.InputGroup > */}
                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Landmark  </label>
                                        <Field type="text" name="instLandmark" className="form-control mb-2" maxLength="30" />
                                        <ErrorMessage name="instLandmark" component="div" className="text-error" />
                                        {/* </bie.InputGroup> */}
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                        <label classname='mb-1' className="label-text-style">Off Campus Address</label>
                                        <Field as="textarea" name="offCampusAddress" className="form-control mb-2" maxLength="350" />

                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                        {/* <bie.InputGroup > */}
                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Mobile No   </label>
                                        <Field type="text" name="instMobile" className="form-control mb-2" maxLength='10' onKeyPress={(e) => { allowNumbersOnly(e) }} onPaste={(e) => handlePaste(e)} />
                                        <ErrorMessage name="instMobile" component="div" className="text-error" />
                                        {/* </bie.InputGroup> */}
                                    </bie.Col>

                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}  >
                                        {/* <bie.InputGroup> */}
                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Email ID </label>
                                        <Field type="email" name="instEmail" className="form-control mb-2" maxLength="50" />
                                        <ErrorMessage name="instEmail" component="div" className="text-error" />
                                        {/* </bie.InputGroup> */}
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                        {/* <bie.InputGroup > */}
                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Office Landline(Phone No.)  </label>
                                        <Field type="text" name="instPhone" className="form-control mb-2" maxLength='10' onKeyPress={(e) => { allowNumbersOnly(e) }} onPaste={(e) => handlePaste(e)} />
                                        <ErrorMessage name="instPhone" component="div" className="text-error" />
                                        {/* </bie.InputGroup> */}
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                        {/* <bie.InputGroup > */}
                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>College Website</label>
                                        <Field type="text" name="instWebsite" className="form-control mb-2" maxLength='35' />
                                        <ErrorMessage name="instWebsite" component="div" className="text-error" />
                                        {/* </bie.InputGroup> */}
                                    </bie.Col>



                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}  >
                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Category of the College </label>
                                        <Field as="select" name="instStatus" className="form-control mb-2" >
                                            <option value=''>--SELECT--</option><option value="Co_Education">Co-Education</option><option value="Men">Men</option><option value="Women">Women</option>
                                        </Field>
                                        <ErrorMessage name="instStatus" component="div" className="text-error" />
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                                        <label classname='mb-1' className="label-text-style">Off Campus Category </label>
                                        <Field as="select" name="offCampusInstStatus" className="form-control mb-2" >
                                            <option value=''>--SELECT--</option>
                                            <option value="Co_Education">Co-Education</option><option value="Men">Men</option><option value="Women">Women</option>
                                        </Field>

                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Having Minority Status</label>
                                        <Field as="select" name="instMinority" className="form-control mb-2"
                                            onChange={(e) => {
                                                if (e.target.value === 'false') {
                                                    formik.setFieldValue('otherSpecificMinority', '')
                                                    formik.setFieldValue('instMinorityType', '')
                                                    formik.setFieldValue('minorityStatCerti', '')
                                                }
                                            }}>
                                            <option value=''>--SELECT--</option><option value="true">Yes</option><option value="false">No</option>
                                        </Field>
                                        <ErrorMessage name="instMinority" component="div" className="text-error" />
                                    </bie.Col>
                                    {formik?.values?.instMinority == "true" && (<>

                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                            <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Minority Type</label>
                                            <Field as="select" name="instMinorityType" className="form-control mb-2"
                                                onChange={(e) => {
                                                    if (e.target.value != 'OS') {
                                                        formik.setFieldValue('otherSpecificMinority', '')
                                                    }
                                                }}>
                                                <option value=''>--SELECT--</option><option value="MM">Muslim Minority </option><option value="LM">Linguistic Minority </option><option value="CM">Christian Minority</option><option value="OS">Others</option>
                                            </Field>
                                            <ErrorMessage name="instMinorityType" component="div" className="text-error" />
                                        </bie.Col>
                                        {formik?.values?.instMinorityType === "OS" && (
                                            <>
                                                <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                                    <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>If Others, then Specify</label>
                                                    <Field type="text" name="otherSpecificMinority" className="form-control mb-2" maxLength="70" />
                                                    <ErrorMessage name="otherSpecificMinority" component="div" className="text-error" />
                                                </bie.Col></>)}
                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                            <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Upload Minority Certificate</label>
                                            <div className="d-flex align-items-center">
                                                <input type="file" name="minorityStatCerti" className="form-control mb-2" accept="application/pdf"
                                                    onChange={(e) => {
                                                        let filename = `minorityStatCerti`;
                                                        let path = "/Uploads/AffiliationPDFs/2023/"
                                                        ImagePdfBucket(e, formik, path, `minorityStatCerti`, filename, "pdf");
                                                    }}
                                                />
                                                {formik?.values?.minorityStatCerti && Application?.minority_stat_certi !== '' && <button type='button' className='ms-3 btn btn-primary' onClick={() => { viewImage(Application?.minority_stat_certi) }}><FaEye size={23} /></button>}
                                            </div>

                                            <ErrorMessage name="minorityStatCerti" component="div" className="text-error" />
                                        </bie.Col>
                                    </>)}
                                    {/* 
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                        <label classname='mb-1' className="label-text-style">
                                            College Aishe Code
                                        </label>
                                        <Field type="text" name="collAisheCode" className="form-control down-marg4" maxLength="12" onBlur={(e) => { GetCfmsData(e?.target?.value); }} />
                                    </bie.Col> */}



                                    <bie.Row className="align-items-center">

                                        {/* AISHE Code */}
                                        <bie.Col lg={3}>
                                            <label>College AISHE Code</label>
                                            <input
                                                type="text"
                                                name="collAisheCode" className="form-control down-marg4" maxLength="12" onBlur={(e) => { GetCfmsData(e?.target?.value); }} />
                                        </bie.Col>
                                        {cfmsdata?.length > 0 && (


                                            <bie.Col lg={9} className="d-flex align-items-center">
                                                <span style={{ fontWeight: "600", marginRight: "6px" }}>
                                                    Institution Name as per AISHE Details:
                                                </span>
                                                <span style={{ color: "green", fontWeight: "100px" }}>
                                                    {cfmsdata[0]?.inst_name || "-"}
                                                </span>
                                            </bie.Col>
                                        )}



                                    </bie.Row>
                                </bie.Row>
                            </div>

                            <div className="inner-herbpage-service-title-sub"  >
                                <h1 className="mb-0 ">Examination & CET Details</h1>
                            </div>


                            <p style={{ color: "red", fontSize: "12px", marginTop: "12px" }} >Note  :For OAMDC Course Enter JNB Code</p>
                            <div className="table-responsive">
                                <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                    <thead>
                                        <tr>
                                            <th>SNO</th>
                                            <th>CET Name</th>
                                            <th>CET Code</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <FieldArray name="cetsmapped">
                                            {({ push, remove }) => (formik?.values?.cetsmapped?.map((college, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <center>{index + 1}</center>
                                                    </td>
                                                    <td>
                                                        <Field
                                                            as="select"
                                                            name={`cetsmapped[${index}].collCetName`}
                                                            className="form-control form-control-md"
                                                            onChange={(e) => {
                                                                const selectedValue = e.target.value;
                                                                if (selectedValue) {
                                                                    const isDuplicate = formik?.values?.cetsmapped
                                                                        .some((item, idx) => item.collCetName === selectedValue && idx !== index);
                                                                    if (isDuplicate) {
                                                                        Swal.fire({
                                                                            icon: 'info',
                                                                            title: 'Duplicate Entry',
                                                                            text: `This ${selectedValue} Name has already been selected. Please select another CET Name.`,
                                                                        }).then(() => {
                                                                            formik.setFieldValue(`cetsmapped[${index}].collCetName`, '');
                                                                            formik.setFieldValue(`cetsmapped[${index}].cetCode`, '');
                                                                        });
                                                                    }
                                                                }
                                                            }}
                                                        >
                                                            <option value="">--select--</option>
                                                            {cetList &&
                                                                cetList?.map((CLG, i) => (
                                                                    <option key={i} value={CLG?.cet_name}>
                                                                        {CLG?.cet_name}
                                                                    </option>
                                                                ))}
                                                        </Field>
                                                        <ErrorMessage name={`cetsmapped[${index}].collCetName`} component="div" className="text-error" />
                                                    </td>
                                                    <td>
                                                        <Field
                                                            type="text"
                                                            name={`cetsmapped[${index}].cetsCode`}
                                                            className="form-control mb-2"
                                                            maxLength="10"
                                                            placeholder={
                                                                formik?.values?.cetsmapped?.[index]?.collCetName
                                                                    ? `Enter ${formik.values.cetsmapped[index].collCetName} Code`
                                                                    : 'Enter CET Code'
                                                            }
                                                        />

                                                        <ErrorMessage name={`cetsmapped[${index}].cetsCode`} component="div" className="text-error" />
                                                    </td>

                                                    <td align="right" colSpan={7} className="text-center">
                                                        {index === 0 ? (
                                                            <button
                                                                type="button"
                                                                className="button-titile btn btn-sm btn-success me-2"
                                                                onClick={() => push({ cetsCode: '' })}
                                                            >
                                                                <VscDiffAdded />
                                                            </button>
                                                        ) : ""}
                                                        {index >= 1 ? (
                                                            <button
                                                                type="button"
                                                                className="button-titile btn btn-sm btn-danger"
                                                                onClick={() => remove(index)}
                                                            >
                                                                <VscDiffRemoved />
                                                            </button>
                                                        ) : ""}

                                                    </td>
                                                </tr>
                                            ))
                                            )}
                                        </FieldArray>
                                    </tbody>
                                </table>
                            </div>
                        </bie.Row>
                        <bie.Row>
                            <bie.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="mt-2">
                                <div className="inner-herbpage-service-title1">
                                    <h1>Approvals</h1>
                                </div>
                            </bie.Col>
                        </bie.Row>
                        <bie.Row className="px-3 pt-2 m-0 ">
                            <div className="inner-herbpage-service-title-sub"  >
                                <h1 className="mb-0">Approvals-Competent Authority (CHE/AICTE/PCI/BCI/NCTE)</h1>
                            </div>
                            <div className="">
                                <bie.Row className="my-3">
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                        {/* <bie.InputGroup > */}
                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Competant Authority for Approval</label>
                                        <Field type="text" name="competantAuthority" className="form-control mb-2" maxLength="30" />
                                        <ErrorMessage name="competantAuthority" component="div" className="text-error" />
                                        {/* </bie.InputGroup> */}
                                    </bie.Col>

                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}  >
                                        {/* <bie.InputGroup> */}
                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Date of Initial Permission </label>
                                        <Field type="date" name="competantAuthorityDate" className="form-control down-marg4" onKeyDown={(e) => { e.preventDefault() }} />
                                        <ErrorMessage name="competantAuthorityDate" component="div" className="text-error" />
                                        {/* </bie.InputGroup> */}
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                        {/* <bie.InputGroup > */}
                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Upload Initial Permission Order </label>
                                        <div className="d-flex align-items-center">
                                            <input type="file" name="competantAuthorityPdf" className="form-control mb-2" accept="application/pdf"
                                                onChange={(e) => {
                                                    let filename = `competantAuthorityPdf`;
                                                    let path = "/Uploads/AffiliationPDFs/2023/"
                                                    ImagePdfBucket(e, formik, path, `competantAuthorityPdf`, filename, "pdf");
                                                }}
                                            /> &nbsp;
                                            {Application?.competant_authority_pdf && <button type='button' className='ms-3 btn btn-primary' onClick={() => { viewImage(Application?.competant_authority_pdf) }}><FaEye className="icon" size={23} /></button>}

                                        </div>
                                        <ErrorMessage name="competantAuthorityPdf" component="div" className="text-error" />
                                        {/* </bie.InputGroup> */}
                                    </bie.Col>
                                </bie.Row>
                                <bie.InputGroup className="d-flex align-items-center px-2">

                                    <bie.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                        <label classname='mb-1'><b style={{ color: 'red' }}>* </b> <b className="me-3">Any change in Address after the issuance of the Initial Permission Order Yes/No : </b></label>
                                        <Field type='radio' name="isEop" value='true' className="mx-2" />
                                        <label classname='mb-1' className="me-3">Yes</label>
                                        <Field type='radio' name="isEop" value='false' className="mx-2"
                                            onChange={() => {
                                                formik?.setFieldValue('latEopDateNew', '')
                                                formik?.setFieldValue('latEopOrderPdfNew', '')
                                            }}
                                        />

                                        <label classname='mb-1' className="me-3">No</label>
                                        <ErrorMessage name='isEop' className='text-error' component='div' />

                                    </bie.Col>

                                </bie.InputGroup>
                                {formik.values.isEop === 'true' && (
                                    <bie.Row className="pt-4 m-0 ">

                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                            <label classname='mb-1' ><b style={{ color: 'red' }}>* </b>Date of Permission for change of address : </label>
                                            <Field type="date" name="latEopDateNew" className="form-control mb-2" onKeyDown={(e) => { e.preventDefault() }} min="1970-01-01" max={new Date().toISOString().split('T')[0]} />
                                            <ErrorMessage name="latEopDateNew" component="div" className="text-error" />
                                        </bie.Col>

                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}  >
                                            <label classname='mb-1' ><b style={{ color: 'red' }}>* </b>Upload Permission proceedings : </label>
                                            <input type="file" name="latEopOrderPdfNew" className="form-control mb-2" accept="application/pdf"
                                                onChange={(e) => {
                                                    let filename = `latEopOrderPdfNew`;
                                                    let path = "/Uploads/AffiliationPDFs/2023/"
                                                    ImagePdfBucket(e, formik, path, `latEopOrderPdfNew`, filename, "pdf");
                                                }}
                                            />
                                            <ErrorMessage name="latEopOrderPdfNew" component="div" className="text-error" />
                                        </bie.Col>
                                        <bie.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}  >
                                            {formik?.values?.latEopOrderPdfNew && Application?.lat_eop_order_pdf_new && <button type='button' className='btn btn-primary' style={{ marginTop: "15%" }} onClick={() => { viewImage(Application?.lat_eop_order_pdf_new) }}><FaEye size={23} /></button>}

                                        </bie.Col>


                                    </bie.Row>
                                )}
                            </div>
                            <div className="inner-herbpage-service-title-sub"  >
                                <h1 className="mb-0">Autonomous Status by UGC</h1>
                            </div>
                            <div className=" py-3">
                                <bie.Row className="  m-0  ">
                                    <bie.Col xs={12} sm={12} md={12} lg={12} xl={5} xxl={3} >
                                        <label><b style={{ color: 'red' }}>* </b> Status By UGC</label>
                                        <div className="">
                                            <div className="form-control">
                                                <Field type="radio" name="automusNonautomus" value='A' />&nbsp;&nbsp;Autonomous&nbsp;&nbsp;
                                                <Field type="radio" name="automusNonautomus" value='N'
                                                    onClick={() => {
                                                        formik.setFieldValue('ugcStatDateUpFrom', '')
                                                        formik.setFieldValue('ugcStatDateUpto', '')
                                                        formik.setFieldValue('ugcYrAfflOrder', '')
                                                    }}
                                                />&nbsp;&nbsp;Non-Autonomous
                                            </div>
                                            <ErrorMessage name="automusNonautomus" component="div" className="text-error" />
                                        </div>
                                    </bie.Col>
                                    {formik?.values?.automusNonautomus === 'A' && (
                                        <>
                                            <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}  >
                                                {/* <bie.InputGroup> */}
                                                <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Valid From Date </label>
                                                <Field type="date" name="ugcStatDateUpFrom" className="form-control mb-2" onClick={() => formik.setFieldValue('ugcStatDateUpto', '')} onKeyDown={(e) => { e.preventDefault() }} />
                                                <ErrorMessage name="ugcStatDateUpFrom" component="div" className="text-error" />
                                                {/* </bie.InputGroup> */}
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                                {/* <bie.InputGroup > */}
                                                <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Valid Till Date  </label>
                                                <Field type="date" name="ugcStatDateUpto" className="form-control mb-2" min={formik.values.ugcStatDateUpFrom} onKeyDown={(e) => { e.preventDefault() }} />
                                                <ErrorMessage name="ugcStatDateUpto" component="div" className="text-error" />
                                                {/* </bie.InputGroup> */}
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} classname='mb-3  '>
                                                {/* <bie.InputGroup > */}
                                                <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Upload UGC latest Order </label>
                                                <input type="file" name="ugcYrAfflOrder" className="form-control mb-2" accept="application/pdf"
                                                    onChange={(e) => {
                                                        let filename = `ugcYrAfflOrder`;
                                                        let path = "/Uploads/AffiliationPDFs/2023/"
                                                        ImagePdfBucket(e, formik, path, `ugcYrAfflOrder`, filename, "pdf");
                                                    }}
                                                />
                                                <ErrorMessage name="ugcYrAfflOrder" component="div" className="text-error" />
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}  >

                                                {formik?.values?.ugcYrAfflOrder && Application?.ugc_yr_affl_order && <button type='button' className='btn btn-primary' style={{ marginTop: "15%" }} onClick={() => { viewImage(Application?.ugc_yr_affl_order) }}><FaEye size={23} /></button>}

                                                {/* </bie.InputGroup> */}
                                            </bie.Col>
                                        </>
                                    )}
                                </bie.Row>
                            </div>
                            <div className="inner-herbpage-service-title-sub"  >
                                <h1 className="mb-0">Autonomous Status by University</h1>
                            </div>
                            <div className=" py-3">
                                <bie.Row className=" m-0  ">
                                    <bie.Col xs={12} sm={12} md={12} lg={12} xl={5} xxl={3} >
                                        <label><b style={{ color: 'red' }}>* </b>Status by University</label>
                                        <div className="form-control">
                                            <Field type="radio" name="autoNonautoUniv" value='A' />&nbsp;&nbsp;Autonomous&nbsp;&nbsp;
                                            <Field type="radio" name="autoNonautoUniv" value='N'
                                            // onClick={() => {
                                            //     formik.setFieldValue('univStatDateFrom', '')
                                            //     formik.setFieldValue('univStatDateUpto', '')
                                            //     formik.setFieldValue('universityYrAfflOrder', '')
                                            // }}
                                            /> &nbsp;Non-Autonomous
                                        </div>
                                        <ErrorMessage name="autoNonautoUniv" component="div" className="text-error" />
                                    </bie.Col>
                                    {formik?.values?.autoNonautoUniv === 'A' && (
                                        <>
                                            <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={2}  >
                                                {/* <bie.InputGroup> */}
                                                <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Valid From Date </label>
                                                <Field type="date" name="univStatDateFrom" className="form-control down-marg4" onClick={() => { formik.setFieldValue('univStatDateUpto', '') }} onKeyDown={(e) => { e.preventDefault() }} />
                                                <ErrorMessage name="univStatDateFrom" component="div" className="text-error" />
                                                {/* </bie.InputGroup> */}
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={2} >
                                                {/* <bie.InputGroup > */}
                                                <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Valid Till Date  </label>
                                                <Field type="date" name="univStatDateUpto" className="form-control down-marg4" min={formik.values.univStatDateFrom} onKeyDown={(e) => { e.preventDefault() }} />
                                                <ErrorMessage name="univStatDateUpto" component="div" className="text-error" />
                                                {/* </bie.InputGroup> */}
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} classname='mb-3 '>
                                                {/* <bie.InputGroup > */}
                                                <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Upload University Issued Order </label>
                                                <input type="file" name="universityYrAfflOrder" className="form-control mb-2" accept="application/pdf"
                                                    onChange={(e) => {
                                                        let filename = `universityYrAfflOrder`;
                                                        let path = "/Uploads/AffiliationPDFs/2023/"
                                                        ImagePdfBucket(e, formik, path, `universityYrAfflOrder`, filename, "pdf");
                                                    }}
                                                />
                                                <ErrorMessage name="universityYrAfflOrder" component="div" className="text-error" />
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1} classname='mb-3 '>


                                                {formik?.values?.universityYrAfflOrder && Application?.university_yr_affl_order && <button type='button' className='btn btn-primary' style={{ marginTop: "15%" }} onClick={() => { viewImage(Application?.university_yr_affl_order) }}><FaEye size={23} /></button>}

                                                {/* </bie.InputGroup> */}
                                            </bie.Col>
                                        </>
                                    )}
                                </bie.Row>
                            </div>
                            <div className="inner-herbpage-service-title-sub"  >
                                <h1 className="mb-0">UGC recognition Details</h1>
                            </div>
                            <div className=" py-3">
                                <bie.Row className="px-2  m-0  ">
                                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={5} xxl={3}  >
                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Whether the College has 2(f) & 12B or Both </label>

                                        <Field as="select" name="instUgc" className="form-control mb-2"
                                            onChange={(e) => {
                                                if (e.target.value === 'No') {
                                                    formik.setFieldValue('instUgcType', '')
                                                    formik.setFieldValue('ugcCerti', '')
                                                }
                                            }}>
                                            <option value=''>--SELECT--</option><option value="Yes">Yes</option><option value="No">No</option>
                                        </Field>
                                        <ErrorMessage name="instUgc" component="div" className="text-error" />
                                    </bie.Col>
                                    {formik?.values?.instUgc == 'Yes' && (
                                        <>
                                            <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} >
                                                <label classname='mb-1' className="label-text-style affl-downmarg"><b style={{ color: 'red' }}>* </b>Type   </label>
                                                <Field as="select" name="instUgcType" className="form-control down-marg4" >
                                                    <option value=''>--SELECT--</option>
                                                    <option value="1">2(f) alone</option>
                                                    <option value="3">Both (2(f) & 12B)</option>
                                                </Field>
                                                <ErrorMessage name="instUgcType" component="div" className="text-error" />
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} classname='mb-3 ,t-4 '>
                                                {/* <bie.InputGroup > */}
                                                <label classname='mb-1' className="label-text-style affl-downmarg"><b style={{ color: 'red' }}>* </b>Upload UGC Certificate </label>
                                                <input type="file" name="ugcCerti" className="form-control down-marg4" accept="application/pdf"
                                                    onChange={(e) => {
                                                        let filename = `ugcCerti`;
                                                        let path = "/Uploads/AffiliationPDFs/2023/"
                                                        ImagePdfBucket(e, formik, path, `ugcCerti`, filename, "pdf");
                                                    }} />&emsp;

                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}  >

                                                {formik?.values?.ugcCerti && Application?.ugc_certi && <button type='button' className='btn btn-primary' style={{ marginTop: "15%" }} onClick={() => { viewImage(Application?.ugc_certi) }}><FaEye size={23} /></button>}

                                                <ErrorMessage name="ugcCerti" component="div" className="text-error" />
                                                {/* </bie.InputGroup> */}
                                            </bie.Col>
                                        </>
                                    )}
                                </bie.Row>
                            </div>




                            <div className="inner-herbpage-service-title-sub"  >
                                <h1 className="mb-0">College  NAAC Accreditation Details</h1>
                            </div>
                            <div className=" py-3 mb-3">
                                {/* <bie.Row className=" pt-4 m-0 ">
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='mb-4'>
                                        <label classname='mb-1' ><b style={{ color: 'red' }}>* </b><b>Whether Accredited by NAAC :</b></label>
                                        <Field as="select" name="naacAccredited" className="form-control mb-2"
                                            onChange={(e) => {
                                                if (e.target.value === 'A' || e.target.value === 'No') {
                                                    formik.setFieldValue('naacStatus', '')
                                                    formik.setFieldValue('naacCycle', '')
                                                    formik.setFieldValue('naacFromDate', '')
                                                    formik.setFieldValue('naacUptoDate', '')
                                                    formik.setFieldValue('naacAccredCerti', '')
                                                    formik.setFieldValue('naacCgpa', '')
                                                    document.getElementById("naacAccredCerti").value = null;

                                                }
                                            }}>

                                            <option value=''>--SELECT--</option><option value="Yes">Accredited</option><option value="A">Applied</option><option value="No">Not Yet Applied</option>
                                        </Field>
                                        <ErrorMessage name="naacAccredited" component="div" className="text-error" />
                                    </bie.Col>
                                    {formik?.values?.naacAccredited === 'Yes' && (
                                        <>
                                            <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                                <label classname='mb-1' className="label-text-style">
                                                    <b style={{ color: 'red' }}>* </b>NAAC Grade
                                                </label>

                                                <Field as="select" name="naacStatus" className="form-control down-marg4">

                                                    <option value=''>--SELECT--</option>
                                                    <option value="A">A</option>
                                                    <option value="A+">A+</option>
                                                    <option value="A++">A++</option>
                                                    <option value="B">B</option>
                                                    <option value="B+">B+</option>
                                                    <option value="B++">B++</option>
                                                    <option value="C">C</option>
                                                    <option value="D">D</option>



                                                </Field>

                                                <ErrorMessage name="naacStatus" component="div" className="text-error" />
                                            </bie.Col>


                                            <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                                <label classname='mb-1' className="label-text-style">
                                                    <b style={{ color: 'red' }}>* </b>NAAC Cycle
                                                </label>
                                                <Field
                                                    as="select"
                                                    name="naacCycle"
                                                    className="form-control down-marg4"
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        formik.setFieldValue("naacCycle", value);

                                                        if (value) {
                                                            const count = parseInt(value);
                                                            const newArray = Array.from({ length: count }, () => ({
                                                                naacFromDate: '',
                                                                naacUptoDate: '',
                                                                naacAccredCerti: '',
                                                                naacCgpa: ''
                                                            }));

                                                            formik.setFieldValue("naacDetails", newArray);
                                                        } else {
                                                            formik.setFieldValue("naacDetails", []);
                                                        }
                                                    }}
                                                >
                                                    <option value=''>--SELECT--</option>
                                                    <option value="1">1</option>
                                                    <option value="2">2</option>
                                                    <option value="3">3</option>
                                                    <option value="4">4</option>
                                                    <option value="5">5</option>
                                                    <option value="6">6</option>

                                                </Field>
                                                <ErrorMessage name="naacCycle" component="div" className="text-error" />

                                            </bie.Col>

                                            <FieldArray name="naacDetails">
                                                {() => (
                                                    formik?.values?.naacDetails?.map((item, index) => (

                                                        <div key={index} className="row border p-2 mb-3">

                                                            <h6>Cycle {index + 1}</h6>

                                                            <bie.Col lg={3}>
                                                                <label className="label-text-style">
                                                                    <b style={{ color: 'red' }}>* </b>NAAC Valid From Date
                                                                </label>
                                                                <Field
                                                                    type="date"
                                                                    name={`naacDetails[${index}].naacFromDate`}
                                                                    className="form-control down-marg4"
                                                                    onChange={(e) => {
                                                                        formik.setFieldValue(`naacDetails[${index}].naacFromDate`, e.target.value);
                                                                        formik.setFieldValue(`naacDetails[${index}].naacUptoDate`, '');
                                                                    }}
                                                                />
                                                                <ErrorMessage name={`naacDetails[${index}].naacFromDate`} component="div" className="text-error" />
                                                            </bie.Col>

                                                            <bie.Col lg={3}>
                                                                <label className="label-text-style">
                                                                    <b style={{ color: 'red' }}>* </b>NAAC Valid Till Date
                                                                </label>
                                                                <Field
                                                                    type="date"
                                                                    name={`naacDetails[${index}].naacUptoDate`}
                                                                    className="form-control down-marg4"
                                                                    min={formik?.values?.naacDetails?.[index]?.naacFromDate}
                                                                />
                                                                <ErrorMessage name={`naacDetails[${index}].naacUptoDate`} component="div" className="text-error" />
                                                            </bie.Col>

                                                            <bie.Col lg={3}>
                                                                <label className="label-text-style">
                                                                    <b style={{ color: 'red' }}>* </b>Upload Certificate
                                                                </label>

                                                                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>

                                                                    <input
                                                                        type="file"
                                                                        className="form-control"
                                                                        accept="application/pdf"
                                                                        onChange={(e) => {
                                                                            let filename = `naacAccredCerti_${index}`;
                                                                            let path = "/Uploads/AffiliationPDFs/2023/";

                                                                            ImagePdfBucket(
                                                                                e,
                                                                                formik,
                                                                                path,
                                                                                `naacDetails[${index}].naacAccredCerti`,
                                                                                filename,
                                                                                "pdf"
                                                                            );
                                                                        }}
                                                                    />

                                                                    {formik?.values?.naacDetails?.[index]?.naacAccredCerti &&
                                                                        !["null", "nullnull", ""].includes(
                                                                            formik.values.naacDetails[index].naacAccredCerti
                                                                        ) && (
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-primary"
                                                                                onClick={() =>
                                                                                    viewImage(formik.values.naacDetails[index].naacAccredCerti)
                                                                                }
                                                                            >
                                                                                <FaEye size={18} />
                                                                            </button>
                                                                        )}
                                                                </div>

                                                                <ErrorMessage
                                                                    name={`naacDetails[${index}].naacAccredCerti`}
                                                                    component="div"
                                                                    className="text-error"
                                                                />
                                                            </bie.Col>

                                                            <bie.Col lg={3}>
                                                                <label className="label-text-style">
                                                                    <b style={{ color: 'red' }}>* </b>NAAC CGPA
                                                                </label>
                                                                <Field
                                                                    type="text"
                                                                    name={`naacDetails[${index}].naacCgpa`}
                                                                    className="form-control mb-2"
                                                                    maxLength="4"
                                                                />
                                                                <ErrorMessage name={`naacDetails[${index}].naacCgpa`} component="div" className="text-error" />

                                                            </bie.Col>

                                                        </div>
                                                    ))
                                                )}
                                            </FieldArray>
                                        </>
                                    )}
                                </bie.Row> */}

                                <bie.Row className="pt-4 m-0 align-items-center">
                                    <bie.Col lg={3} className="mb-4">
                                        <label className="mb-0">
                                            <b style={{ color: 'red' }}>* </b>
                                            <b>Whether Accredited by NAAC :</b>
                                        </label>
                                    </bie.Col>

                                    <bie.Col lg={3} className="mb-4">
                                        <Field
                                            as="select"
                                            name="naacAccredited"
                                            className="form-control"
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                formik.setFieldValue("naacAccredited", value);

                                                // RESET ALL
                                                formik.setFieldValue("naacStatus", "");
                                                formik.setFieldValue("latestNaacFromDate", "");
                                                formik.setFieldValue("latestNaacUptoDate", "");
                                                formik.setFieldValue("latestNaacCerti", "");
                                                formik.setFieldValue("latestNaacCgpa", "");
                                                formik.setFieldValue("hasPreviousNaac", "");
                                                formik.setFieldValue("naacCycle", "");
                                                formik.setFieldValue("naacDetails", []);
                                            }}
                                        >
                                            <option value="">--SELECT--</option>
                                            <option value="Yes">Accredited</option>
                                            <option value="A">Applied</option>
                                            <option value="No">Not Yet Applied</option>
                                        </Field>

                                        <ErrorMessage name="naacAccredited" component="div" className="text-danger" />
                                    </bie.Col>
                                </bie.Row>
                                {/* ================= Latest NAAC ================= */}
                                {formik.values.naacAccredited === "Yes" && (
                                    <div className="border p-3 mt-3 bg-light rounded">
                                        <h6 className="text-primary">Latest NAAC Details</h6>

                                        <div className="row">
                                            <div className="col-md-3">
                                                <label><b style={{ color: "red" }}>* </b> Grade</label>
                                                <Field as="select" name="naacStatus" className="form-control">
                                                    <option value="">--SELECT--</option>
                                                    <option value="A">A</option>
                                                    <option value="A+">A+</option>
                                                    <option value="A++">A++</option>
                                                    <option value="B">B</option>
                                                    <option value="B+">B+</option>
                                                    <option value="B++">B++</option>
                                                    <option value="C">C</option>
                                                    <option value="D">D</option>
                                                </Field>
                                                <ErrorMessage name="naacStatus" component="div" className="text-danger" />

                                            </div>
                                            <div className="col-md-3">
                                                <label><b style={{ color: "red" }}>* </b>CGPA</label>
                                                <Field type="text" name="latestNaacCgpa" className="form-control" />
                                                <ErrorMessage name="latestNaacCgpa" component="div" className="text-danger" />

                                            </div>

                                            <div className="col-md-3">
                                                <label><b style={{ color: "red" }}>* </b> From Date</label>
                                                <Field type="date" name="latestNaacFromDate" className="form-control" />
                                                <ErrorMessage name="latestNaacFromDate" component="div" className="text-danger" />

                                            </div>

                                            <div className="col-md-3">
                                                <label><b style={{ color: "red" }}>* </b> To Date</label>
                                                <Field type="date" name="latestNaacUptoDate" className="form-control" />
                                                <ErrorMessage name="latestNaacUptoDate" component="div" className="text-danger" />

                                            </div>


                                            <div className="col-md-4 mt-2">
                                                <label> <b style={{ color: "red" }}>* </b>Upload Certificate</label>
                                                <input
                                                    type="file"
                                                    className="form-control"

                                                    onChange={(e) => {
                                                        let filename = `latestNaacCerti`;
                                                        let path = "/Uploads/AffiliationPDFs/2023/";

                                                        ImagePdfBucket(
                                                            e,
                                                            formik,
                                                            path,
                                                            `latestNaacCerti`,
                                                            filename,
                                                            "pdf"
                                                        );
                                                    }}
                                                />
                                                {formik?.values?.latestNaacCerti &&
                                                    !["null", "nullnull", ""].includes(
                                                        formik.values.latestNaacCerti
                                                    ) && (
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary"
                                                            onClick={() =>
                                                                viewImage(formik.values.latestNaacCerti)
                                                            }
                                                        >
                                                            <FaEye size={18} />
                                                        </button>
                                                    )}
                                                <ErrorMessage name="latestNaacCerti" component="div" className="text-danger" />

                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* ================= Previous NAAC ================= */}
                                {formik.values.naacAccredited === "Yes" && (
                                    <div className="mt-4 d-flex align-items-center">
                                        <label className="me-3 mb-0">
                                            <b style={{ color: "red" }}>* </b>  Previous NAAC Cycle's Available?
                                        </label>

                                        <label className="me-3 mb-0">
                                            <Field
                                                type="radio"
                                                name="hasPreviousNaac"
                                                value="Yes"
                                                onChange={() => {
                                                    formik.setFieldValue("hasPreviousNaac", "Yes");
                                                    formik.setFieldValue("naacCycle", "");
                                                    formik.setFieldValue("naacDetails", []);
                                                }}
                                            />
                                            {" "}Yes
                                        </label>

                                        <label className="mb-0">
                                            <Field
                                                type="radio"
                                                name="hasPreviousNaac"
                                                value="No"
                                                onChange={() => {
                                                    formik.setFieldValue("hasPreviousNaac", "No");
                                                    formik.setFieldValue("naacCycle", "");
                                                    formik.setFieldValue("naacDetails", []);
                                                }}
                                            />
                                            {" "}No
                                        </label>
                                        <ErrorMessage name="hasPreviousNaac" component="div" className="text-danger ms-2" />

                                    </div>
                                )}

                                {/* ================= Cycle ================= */}
                                {formik.values.hasPreviousNaac === "Yes" && (
                                    <div className="mt-3 d-flex align-items-center">
                                        <label className="me-2 mb-0" style={{ minWidth: "120px" }}>
                                            <b style={{ color: "red" }}>* </b>NAAC Cycle
                                        </label>

                                        <Field
                                            as="select"
                                            name="naacCycle"
                                            className="form-control"
                                            onChange={(e) => {
                                                const count = parseInt(e.target.value || 0);

                                                formik.setFieldValue("naacCycle", e.target.value);

                                                if (count > 0) {
                                                    const arr = Array.from({ length: count }, () => ({
                                                        naacFromDate: "",
                                                        naacUptoDate: "",
                                                        naacAccredCerti: "",
                                                        naacCgpa: "",
                                                        naacStatus: "",
                                                    }));
                                                    formik.setFieldValue("naacDetails", arr);
                                                } else {
                                                    formik.setFieldValue("naacDetails", []);
                                                }
                                            }}
                                            style={{ maxWidth: "200px" }}
                                        >
                                            <option value="">--SELECT--</option>
                                            {[1, 2, 3, 4, 5, 6].map(n => (
                                                <option key={n} value={n}>{n}</option>
                                            ))}
                                        </Field>
                                        <ErrorMessage name="naacCycle" component="div" className="text-danger ms-2" />
                                    </div>
                                )}

                                {/* ================= FieldArray ================= */}
                                {formik.values.hasPreviousNaac === "Yes" &&
                                    formik?.values?.naacCycle && (
                                        <FieldArray name="naacDetails">
                                            {() =>
                                                formik?.values?.naacDetails?.map((item, index) => (
                                                    <div
                                                        key={index}
                                                        className="mt-4 p-3 rounded shadow-sm"
                                                        style={{
                                                            borderLeft: "4px solid #0d6efd",
                                                            background: "#f8f9fa"
                                                        }}
                                                    >
                                                        <h6 className="text-primary">
                                                            Previous Cycle {index + 1}
                                                        </h6>

                                                        <div className="row">
                                                            <div className="col-md-3">
                                                                <label><b style={{ color: "red" }}>* </b>NAAC Grade</label>
                                                                <Field as="select" className="form-control" name={`naacDetails[${index}].naacStatus`}>
                                                                    <option value="">--SELECT--</option>
                                                                    <option value="A">A</option>
                                                                    <option value="A+">A+</option>
                                                                    <option value="A++">A++</option>
                                                                    <option value="B">B</option>
                                                                    <option value="B+">B+</option>
                                                                    <option value="B++">B++</option>
                                                                    <option value="C">C</option>
                                                                    <option value="D">D</option>
                                                                </Field>
                                                                <ErrorMessage
                                                                    name={`naacDetails[${index}].naacStatus`}
                                                                    component="div"
                                                                    className="text-danger"
                                                                />
                                                            </div>

                                                            <div className="col-md-3">
                                                                <label><b style={{ color: "red" }}>* </b>NAAC CGPA</label>
                                                                <Field
                                                                    type="text"
                                                                    name={`naacDetails[${index}].naacCgpa`}
                                                                    className="form-control"
                                                                />
                                                                <ErrorMessage
                                                                    name={`naacDetails[${index}].naacCgpa`}
                                                                    component="div"
                                                                    className="text-danger"
                                                                />
                                                            </div>
                                                            <div className="col-md-3">
                                                                <label><b style={{ color: "red" }}>* </b> From Date</label>
                                                                <Field
                                                                    type="date"
                                                                    name={`naacDetails[${index}].naacFromDate`}
                                                                    className="form-control"
                                                                />
                                                                <ErrorMessage
                                                                    name={`naacDetails[${index}].naacFromDate`}
                                                                    component="div"
                                                                    className="text-danger"
                                                                />
                                                            </div>

                                                            <div className="col-md-3">
                                                                <label><b style={{ color: "red" }}>* </b> To Date</label>
                                                                <Field
                                                                    type="date"
                                                                    name={`naacDetails[${index}].naacUptoDate`}
                                                                    className="form-control"
                                                                />
                                                                <ErrorMessage
                                                                    name={`naacDetails[${index}].naacUptoDate`}
                                                                    component="div"
                                                                    className="text-danger"
                                                                />
                                                            </div>


                                                            <div className="col-md-3">
                                                                <label><b style={{ color: "red" }}>* </b>Upload Certificate</label>
                                                                <input
                                                                    type="file"
                                                                    className="form-control"
                                                                    name={`naacDetails[${index}].naacAccredCerti`}

                                                                    onChange={(e) => {
                                                                        let filename = `naacAccredCerti_${index}`;
                                                                        let path = "/Uploads/AffiliationPDFs/2023/";

                                                                        ImagePdfBucket(
                                                                            e,
                                                                            formik,
                                                                            path,
                                                                            `naacDetails[${index}].naacAccredCerti`,
                                                                            filename,
                                                                            "pdf"
                                                                        );
                                                                    }}
                                                                />

                                                                {formik?.values?.naacDetails?.[index]?.naacAccredCerti &&
                                                                    !["null", "nullnull", ""].includes(
                                                                        formik?.values?.naacDetails[index]?.naacAccredCerti
                                                                    ) && (
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-primary"
                                                                            onClick={() =>
                                                                                viewImage(formik?.values?.naacDetails[index]?.naacAccredCerti)
                                                                            }
                                                                        >
                                                                            <FaEye size={18} />
                                                                        </button>
                                                                    )}
                                                                <ErrorMessage
                                                                    name={`naacDetails[${index}].naacAccredCerti`}
                                                                    component="div"
                                                                    className="text-danger"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                        </FieldArray>
                                    )}





                                {/* ////////////// */}

                                {clgtype !== "oamdc" && (<>
                                    <div className="inner-herbpage-service-title-sub"  >
                                        <h1 className="mb-0">College  NBA Accreditation Details</h1>
                                    </div>
                                    <bie.Row className="pt-3 m-0  ">
                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='mb-5'>
                                            <label classname='mb-1' ><b style={{ color: 'red' }}>* </b><b>Whether Accredited by NBA :</b></label>
                                            <Field as="select" name="nbaAccrediated" className="form-control mb-2"
                                                onChange={(e) => {
                                                    if (e.target.value === 'A' || e.target.value === 'No') {
                                                        formik?.setFieldValue('nbaFromDate', '')
                                                        formik?.setFieldValue('nbaUptoDate', '')
                                                        formik?.setFieldValue('nbaAccredCerti', '')
                                                        formik?.setFieldValue('nbaCgpa', '')
                                                        document.getElementById("nbaAccredCerti").value = null;

                                                    }
                                                }}>
                                                <option value=''>--SELECT--</option><option value="Yes">Conferred</option><option value="A">Applied</option><option value="No">Not Yet Applied</option>
                                            </Field>
                                            <ErrorMessage name="nbaAccrediated" component="div" className="text-error" />
                                        </bie.Col>
                                        {formik?.values?.nbaAccrediated === 'Yes' && (
                                            <>
                                                <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}  >
                                                    <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>NBA Valid From Date </label>
                                                    <Field type="date" name="nbaFromDate" className="form-control down-marg4" onClick={() => formik.setFieldValue('nbaUptoDate', '')} onKeyDown={(e) => { e.preventDefault() }} />
                                                    <ErrorMessage name="nbaFromDate" component="div" className="text-error" />
                                                </bie.Col>
                                                <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} classname='mb-4 mt-4'>
                                                    <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>NBA Valid Till Date </label>
                                                    <Field type="date" name="nbaUptoDate" className="form-control down-marg4" min={formik?.values?.nbaFromDate} onKeyDown={(e) => { e.preventDefault() }} />
                                                    <ErrorMessage name="nbaUptoDate" component="div" className="text-error" />
                                                </bie.Col>
                                                <bie.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} classname='mb-4 mt-4'>
                                                    <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Upload NBA Accreditation Certificate </label>
                                                    <input type="file" name="nbaAccredCerti" className="form-control mb-2" accept="application/pdf"
                                                        onChange={(e) => {
                                                            let filename = `nbaAccredCerti`;
                                                            let path = "/Uploads/AffiliationPDFs/2023/"
                                                            ImagePdfBucket(e, formik, path, `nbaAccredCerti`, filename, "pdf");
                                                        }}
                                                    />
                                                    <ErrorMessage name="nbaAccredCerti" component="div" className="text-error" />
                                                </bie.Col>
                                                <bie.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}  >



                                                    {formik?.values?.nbaAccredCerti && Application?.nba_accred_certi && Application.nba_accred_certi.trim() !== 'nullnull' && (
                                                        <button type="button" className=" btn btn-primary" style={{ marginTop: "15%" }} onClick={() => { viewImage(Application.nba_accred_certi); }}>
                                                            <FaEye size={23} />
                                                        </button>
                                                    )}




                                                </bie.Col>
                                                <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} classname='mb-4 mt-4'>
                                                    <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>NBA Marks</label>
                                                    <Field type="text" name="nbaCgpa" className="form-control down-marg4" onKeyPress={(e) => { allowNumbersOnly(e) }} maxLength="4" onPaste={(e) => handlePaste(e)} />
                                                    <ErrorMessage name="nbaCgpa" component="div" className="text-error" />
                                                </bie.Col>

                                            </>)}
                                    </bie.Row>
                                </>)}
                            </div>

                        </bie.Row>
                        <pre /><pre />  <button type='submit' className='btn btn-success btn-sm float-end'>Submit</button><pre />
                    </bie.Container>
                </Form >
            </FormikProvider >
        </>
    )
}